import React, {useState} from "react"
import keyMirror from "keymirror"
import {navigate} from "@reach/router"
import {UseStores} from "../../hooks/UseStores"
import {defaultGeo, shortenNumber} from "../../utils/utils"
import InsightModalPage from "../../pages/InsightModal/InsightModalPage"
import Tooltip from "@material-ui/core/Tooltip"
import {makeStyles} from "@material-ui/core/styles"

const useStyles = makeStyles(() => ({
  tooltip: {
    backgroundColor: "var(--modes-on-primary-container)",
    borderRadius: "4px",
    color: "var(--modes-background)",
    fontFamily: "var(--font-family-regular)",
    fontSize: "var(--font-size-paragraph-large)",
    fontWeight: "var(--font-weight-regular)",
    lineHeight: "var(--line-height)",
    padding: "10px",
    textAlign: "center",
  },
  arrow: {
    color: "var(--modes-on-primary-container)",
  },
}))

export function TableCell({item, cellType, expandedRow}) {
  const cellTypes = keyMirror({
    category: null,
    locations: null,
    visits: null,
    brand: null,
    insights: null,
    brandLocations: null,
  })

  const {insightStore, disStore, timePeriodStore, navStore} = UseStores()

  const classes = useStyles()

  const handleClickBrandLocations = () => {
    const brandId = item.id
    const {geoType, geoId} = defaultGeo
    disStore.setGeoNonePOI(disStore.geoTimeObj.geo)
    navigate(
      `/brands/locations?brandId=${brandId}&geoType=${geoType}&geoId=${geoId}&timePeriod=${timePeriodStore.timePeriod}`
    ) // pass id in url
    navStore.brandId = brandId
  }
  const [open, setOpen] = useState(false)
  let handleInsightPopup = (open) => {
    setOpen(open)
  }
  const handleClickInsights = () => {
    insightStore.brandId = item.id
    insightStore.setInsightType("Market Share")
    insightStore.setInsightMarketTypeFromGeo(disStore.geoTimeObj)
    insightStore.setInsightMarketTypeValueFromGeo(disStore.geoTimeObj)
    handleInsightPopup(true)
  }
  const handleShowInsights = () => {
    navigate("/insights")
  }

  const pinIconText = `Locations`

  const insightsIconText = `Insights`

  let celldata

  switch (cellType) {
    case cellTypes.category:
      celldata = (
        <td
          data-testid="cat-cell"
          className={expandedRow === item.sicCode ? "category-expanded" : "category"}
          colSpan="2"
        >
          <div
            className={expandedRow === item.sicCode ? "minus-icon" : "plus-icon"}
          ></div>
          <span className="category-span">{item.name}</span>
        </td>
      )
      break
    case cellTypes.locations:
      celldata = (
        <td id="num" data-testid="locations-cell">
          {shortenNumber(item.locations)}
        </td>
      )
      break
    case cellTypes.visits:
      celldata = (
        <td id="num" data-testid="visits-cell">
          {shortenNumber(item.visits)}
        </td>
      )
      break
    case cellTypes.brand:
      celldata = (
        <td id="brand-name" data-testid="brand-cell">
          {item.name}
        </td>
      )
      break
    case cellTypes.insights:
      celldata = (
        <td data-testid="insights">
          <InsightModalPage
            key={item.id}
            item={item}
            open={open}
            handleInsightPopup={handleInsightPopup}
            handleShowInsights={handleShowInsights}
          />
          <Tooltip
            title={insightsIconText}
            arrow
            placement="bottom-start"
            classes={{arrow: classes.arrow, tooltip: classes.tooltip}}
          >
            <div className="bar-chart" onClick={handleClickInsights}></div>
          </Tooltip>
        </td>
      )
      break
    case cellTypes.brandLocations:
      celldata = (
        <td data-testid="brand-locations" onClick={handleClickBrandLocations}>
          <Tooltip
            title={pinIconText}
            arrow
            placement="bottom-start"
            classes={{arrow: classes.arrow, tooltip: classes.tooltip}}
          >
            <div className="pin-icon"> </div>
          </Tooltip>
        </td>
      )
      break
    default:
      celldata = <td></td>
  }
  return <React.Fragment>{celldata}</React.Fragment>
}
